import type {ReactNode} from 'react'

// The subscription states in the matrix need a dedicated For You component.
export function getVisitorForYouAction(): ReactNode {
  return null
}
